import {h, Fragment} from "preact"
import Product from './Product'
import { initializeWishlist } from './Product'
import { useAppState, useAppStateSelector } from '@nosto/preact'
import LoadButton from './elements/LoadButton'
import { useEffect, useState } from 'preact/hooks'
import { restoreScrollPosition, saveScrollPosition } from '../helpers'

export default function Products({ swatchData, title }) {
    const { products, loading } = useAppStateSelector((state) => ({
        products: state.response.products,
        loading: state.loading,
    }))
    const [activeProductId, setActiveProductId] = useState(null)
    const [shouldAddBlock, setShouldAddBlock] = useState(null)

    const handleHoverMenu = (productId) => {
        setActiveProductId(productId)
    }

    // Save scroll position
    useEffect(() => {
        // Previous scroll position mobile
        const handleVisChange = () => {
            document.visibilityState === 'visible' ? restoreScrollPosition(10) : saveScrollPosition()
        }

        if (window.innerWidth < 1023) {
            restoreScrollPosition(10)
            window.addEventListener('visibilitychange', handleVisChange)
            return () => {
                window.removeEventListener('visibilitychange', handleVisChange)
            }
        }
    }, [])

    useEffect(() => {
        // console.log('running useEffect for desktop')
        // Previous scroll position chrome + desktop
        const handleUnload = () => {
            saveScrollPosition()
        }

        const handleAnchorClick = (event) => {
            let target = event.target

            // Traverse up the DOM tree to check if the clicked element or any of its parents is an anchor tag
            while (target && target !== document) {
                if (target.tagName === 'A') {
                    saveScrollPosition()
                    break
                }
                target = target.parentElement
            }
        }

        if (window.innerWidth >= 1024) {
            if (products?.hits && products?.hits.length > 0) {
                restoreScrollPosition(10)
            }
            /* popstate triggers only when history entry changes - but only working on desktop */
            window.addEventListener('popstate', handleUnload)
            document.addEventListener('click', handleAnchorClick)

            return () => {
                window.removeEventListener('popstate', handleUnload)
                document.removeEventListener('click', handleAnchorClick)
            }
        }
    }, [products?.hits?.length])

    // Scroll to top on search
    useEffect(() => {
        const desktopInput = document.querySelector('#boost-pfs-search-box-desktop')
        const mobileInput = document.querySelector('#boost-pfs-search-box-mobile')
        const seeAllButton = document.querySelector('.ns-see-all')

        const handleEnterKey = (event) => {
            if (event.key === 'Enter') {
                window.scrollTo(0, 0)
            }
        }

        if (desktopInput) {
            desktopInput.addEventListener('keydown', handleEnterKey)
        }

        if (mobileInput) {
            mobileInput.addEventListener('keydown', handleEnterKey)
        }

        if (seeAllButton) {
            seeAllButton.addEventListener('click', () => {
                window.scrollTo(0, 0)
            })
        }

        // Cleanup event listeners on component unmount
        return () => {
            if (desktopInput) {
                desktopInput.removeEventListener('keydown', handleEnterKey)
            }
            if (mobileInput) {
                mobileInput.removeEventListener('keydown', handleEnterKey)
            }

            if (seeAllButton) {
                seeAllButton.removeEventListener('click', () => {
                    window.scrollTo(0, 0)
                })
            }
        }
    }, [products])

    // Wishlist
    useEffect(() => {
        setTimeout(() => initializeWishlist(), 0);
        window.dtDisplayTags();
        if (window.view_item_handler) {
            setTimeout(window.view_item_handler, 0);
        }
    }, [products])

    useEffect(() => {
        const _shouldAddBlock = title
        if (_shouldAddBlock) {
            document.querySelector('.category-content-block-6')?.remove()
            // add block of div#reserve-block-for-category-content-block-6 on postion 6
            products.hits.splice(5, 0, {
                "id": "reserve-block-for-category-content-block-6",
                "class": "ns-product ns-border-box ns-clickable ns-text-undecorated ns-color-inherit category-content-block-6",
                "style": "display: none !important",
                "type": "block-for-category",
                "index": 5
            })
            document.querySelector('.category-content-block-12')?.remove()
            // add block of div#reserve-block-for-category-content-block-6 on postion 12
            products.hits.splice(11, 0, {
                "id": "reserve-block-for-category-content-block-12",
                "class": "ns-product ns-border-box ns-clickable ns-text-undecorated ns-color-inherit category-content-block-12",
                "style": "display: none !important",
                "type": "block-for-category",
                "index": 11
            })
        }
        setShouldAddBlock(_shouldAddBlock)
        setTimeout(() => {
            window.nostojs(function(api) {
                api.loadRecommendations();
            });
        }, 0)
    }, [products, title])

    useEffect(() => {
        const fire = () => {
            setTimeout(() => {
                window?.ProductSwatchController?.adjustSwatches('diagonal');  
            }, 100);
            setTimeout(() => {
                window?.ProductSwatchController?.adjustSwatches('diagonal');
            }, 250);
            setTimeout(() => {
                window?.ProductSwatchController?.adjustSwatches('diagonal');
            }, 500);
            setTimeout(() => {
                window?.ProductSwatchController?.adjustSwatches('diagonal');
            }, 1000);
            setTimeout(() => {
                window?.ProductSwatchController?.adjustSwatches('diagonal');
            }, 5000);
        };
        
        const dispatch = () => window.dispatchEvent(new Event('locationchange'));
    
        window.addEventListener('popstate', dispatch);
        window.addEventListener('hashchange', dispatch);
    
        // Safari/Firefox BFCache restore and Chromium back/forward
        window.addEventListener('pageshow', (e) => {
        if (e.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
            fire();
        }
        });
    
        // Run on any URL change
        window.addEventListener('locationchange', fire);
    
        // Initial run
        fire();
    }, [swatchData, window.location.href, title]);

    return (
        <>
            <div class="ns-products ns-d-flex ns-flex-wrap" style={loading ? 'opacity: 0.3;' : ''}>
                {products.hits.map((hit, index) => {
                    if (shouldAddBlock && hit?.index === index && hit?.type === "block-for-category") {
                        return <div id={hit.id} class={hit.class} style={hit.style} />
                    }
                    return (
                        <Product
                            swatchData={swatchData}
                            product={hit}
                            key={hit.productId || index}
                            index={index}
                            isActive={activeProductId === hit.productId}
                            onHoverMenu={(productId) => handleHoverMenu(productId)}
                        />
                    )
                })}
            </div>
            {loading && <LoadButton />}
        </>
    )
}
